import { inject, RESPONSE_INIT } from '@angular/core'
import { ResolveFn, Router } from '@angular/router'
import { CustomContent } from '../services/custom-content/custom-content'
import { catchError, map } from 'rxjs'

export const cityContentResolver: ResolveFn<boolean> = (route, state) => {
	const response = inject(RESPONSE_INIT)
	const router = inject(Router)
	const customContentService = inject(CustomContent)

	return customContentService.getCityContent(route.params['city'], route.params['state']).pipe(
		map((resp) => resp),
		catchError((error) => {
			// Here we are catching the error from the content service and setting the response to the server as a 404.
			// This allows us to return a 404 status code for the page while still rendering the Angular application, which can then display a custom 404 page to the user.
			if (error.status === 404 && response) {
				response.status = 404
				response.statusText = error.statusText || 'Not Found'
			}

			return router.navigate(['/404'], { skipLocationChange: true })
		}),
	)
}
